import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
	state: {
		// isSubmited: false,
		// applicationId: 0,
		policyHolder: {
			details: {
				salutationId: null,
				surname: '',
				forename: '',
				dateOfBirth: undefined,
				genderId: undefined,
				residenceCountryId: undefined,
				occupationId: undefined,
				NationalityCountryId: undefined,
			},
			contactDetails: {
				lineNumberCountryCodeId: undefined,
				landlineNumber: '',
				countryCodeMobileId: undefined,
				mobileNumber: '',
				emailAddress: '',
			},
			currentSelectedFamilyIndex: undefined,
			familyMembers: [],
			policyStartDate: undefined,
			currencyId: undefined,
		},

		// Evolution Health
		selectedProductIndex: 0,
		product: {
			productId: 1,
			frequencyId: 0,
			areaId: 1,
			selectedExcessId: 1,
			coInsuranceSelectedId: [],
			hasAdditionalBenefit: false,
		},

		underwritingTypeId: null,

		additionalDetails: {
			// genderId: undefined,
			isSportOrPastime: true,
			otherPastimes: '',
			refusedCoverOrAcceptedOnSpecialTerms: undefined,
			refusedCoverOrAcceptedOnSpecialTermsDate: null,
			refusedCoverOrAcceptedOnSpecialTermsDetails: '',
			haveExistingHealthInsurance: undefined,
			insuranceProvider: null,
			bmi: {
				unit: undefined,
				centimeters: undefined,
				kilograms: undefined,
				feets: undefined,
				inches: undefined,
				stones: undefined,
				pounds: undefined,
			},
			countryResidenceAddress: {
				address1: '',
				address2: '',
				address3: '',
				state: '',
				city: '',
				zipCode: '',
				countryId: undefined,
			},
			homeCountryAddress: {
				address1: '',
				address2: '',
				address3: '',
				state: '',
				city: '',
				zipCode: '',
				countryId: undefined,
			},
			physicianDetails: {
				salutationId: undefined,
				forename: '',
				surname: '',
				practiceName: '',
				dateLastVisited: undefined,
				email: '',
				countryCodeId: undefined,
				telephoneNumber: '',
				address: {
					address1: '',
					address2: '',
					address3: '',
					state: '',
					city: '',
					countryId: undefined,
					zipCode: '',
				},
				// haveExistingHealthInsurance: undefined,
				// insuranceProvider: null,
			},
			documents: {
				passport: [],
				addressProof: [],
			},
		},

		underwritingQuestions: [],
	},
	mutations: {
		updateHolderDetail(state, data) {
			state.policyHolder.details = { ...state.policyHolder.details, ...data }
		},
	},
})
